import CardCategoryArticle from 'components/Frontend/Card/CardCategoryArticle';
import CardContentHome from 'components/Frontend/Card/CardContentHome';
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Swal from 'sweetalert2';
import parse from "html-react-parser";
import UrlImage from "config/UrlImage";
import axiosConfig from 'config/axiosConfig';

function DetailArticle(props) {

    const history = useHistory();
    const [loading, setLoading] = useState(true)
    const [article, setArticle] = useState([])
    const [category, setCategory] = useState([])

    useEffect(() => {
        let isMounted = true;
        const article_slug = props.match.params.slug;
        axiosConfig.get(`/api/article/read/${article_slug}`).then((res) => {
            if (isMounted) {
                if (res.data.status === 200) {
                    setArticle(res.data.article_data.article)
                    setCategory(res.data.article_data.category)
                    setLoading(false)
                } else if (res.data.status === 404) {
                    history.push("/article")
                    Swal.fire("Warning", res.data.message, "warning")
                }
            }
        })
       
        return () => {
            isMounted = false
        }
    }, [props.match.params.slug, history])

    if (loading) {
        return (
            <div className="text-center">
                <div className="spinner-grow text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    } else {
        var showCategory = ''
        showCategory = category.map((item) => {
            return (
                <div className="container" key={item.index}>
                    <div className="row align-items-end">
                        <div className="col">
                            <button className="btn btn-info btn-sm mt-2">{item.name}</button>
                        </div>
                    </div>
                </div>
            )
        })
    }
    return (
        <div className="details-header">
            <div className="py-3">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <div className="card">
                                <div className="card-title">
                                    <h3 className="container mt-4">{article.name}</h3>
                                </div>
                                {showCategory}
                                <div className="card-body">
                                    <p>
                                        <img
                                            src={`${UrlImage}/${article.image}`}
                                            alt="article image"
                                            className="w-100"
                                        />
                                    </p>
                                    <p>{parse(article.description)}</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 ">
                            <CardCategoryArticle />
                        </div>

                        <div className="mt-2">
                            <hr />
                        </div>
                        <CardContentHome />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DetailArticle
